import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import api from '../utils/api';
import moment from 'moment';
import './styles/Kidola.css'; // Adjust the path as necessary

import { useNavigate } from 'react-router-dom';

const ExtraTimeDetailPage = ({ isSidebarCollapsed }) => {
    const { teacherLeaveId } = useParams();
    const [teacherLeave, setTeacherLeave] = useState(null);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchStudentDetails = async () => {
            try {
                const response = await api.get(`/teacher/leave/detail/${teacherLeaveId}`);
                const teacherLeaveData = response.data.data || null;
                setTeacherLeave(teacherLeaveData);
            } catch (error) {
                console.error("Failed to fetch extra time details", error);
            }
        };

        fetchStudentDetails();
        
        
        
        
    }, [teacherLeaveId]);
   
    const handleSubmit = (status) => {
        
        const confirmation = window.confirm('Are you sure you want to proceed with this action?');
        if (!confirmation) {
            return;
        }

        const requestBody = {
            data: {
                teacherLeaveData: {
                    status_name: status  
                }
            }
        };

        api.put(`teacher/leave/update/${teacherLeaveId}`, requestBody)
        .then(response => {
            const successMessage = response.data.message;
            console.log(successMessage);
            navigate('/success', { state: { message: successMessage } });
            
        })
        .catch(error => {
            console.error('Error adding student:', error);
            navigate('/error', { state: { message: 'Please ask to administrator!' } });
        });
    };

    if (!teacherLeave) return <p>Loading Teacher leave details...</p>;

    return (
        <div className={`page-content ${isSidebarCollapsed ? 'collapsed' : ''} spp-payment`}>
            <div className="page-title">Leave Request Detail</div>
            <div className="form-container">
                <div className="section">
                    <h3 className="section-header">Request Data</h3>
                    <table>
                        <tbody>
                            <tr>
                                <td>Teacher Name</td>
                                <td>:</td>
                                <td>{teacherLeave.Teacher.teacher_name}</td>
                            </tr>
                            <tr>
                                <td>Branch</td>
                                <td>:</td>
                                <td>{teacherLeave.Teacher.Branch ? teacherLeave.Teacher.Branch.branch_name : 'CENTRAL'}</td>
                            </tr>
                            <tr>
                                <td>Request Leave Date</td>
                                <td>:</td>
                                <td>{moment(teacherLeave.leave_date).format('DD MMMM YYYY')}</td>
                            </tr>
                            <tr>
                                <td>Status</td>
                                <td>:</td>
                                <td>{teacherLeave.Status.status_name}</td>
                            </tr>
                            <tr>
                                <td>Requested On</td>
                                <td>:</td>
                                <td>{moment(teacherLeave.requested_on).format('DD MMMM YYYY HH:mm:ss')}</td>
                            </tr>
                            {teacherLeave.approved_on!=null ?
                            <tr>
                                <td>Approved On</td>
                                <td>:</td>
                                <td>{moment(teacherLeave.approved_on).format('DD MMMM YYYY HH:mm:ss')}</td>
                            </tr>
                            :""}
                            {teacherLeave.rejected_on!=null ?
                            <tr>
                                <td>Rejected On</td>
                                <td>:</td>
                                <td>{moment(teacherLeave.rejected_on).format('DD MMMM YYYY HH:mm:ss')}</td>
                            </tr>
                            :""}
                        </tbody>
                    </table>
                </div>
                {teacherLeave.Status.status_name === "WAITING APPROVAL"?
                <div className="approve-reject-container">
                    <button className="approve-reject-button" onClick={() => handleSubmit('APPROVED')}>Approve</button>  
                    <button className="profile-button" onClick={() => handleSubmit('REJECTED')}>Reject</button>
                </div>
                :""}
                <div className="search-container">  
                    <button onClick={() => navigate(`/`)}>Back</button>
                </div>
            </div>
        </div>
    );
};

export default ExtraTimeDetailPage;
